import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Home from "@pages/Home";
import PreviewPage from "@pages/PreviewPage";
import Tracker from "@pages/Tracker";
import Manage from "@pages/Manage";
import Reports from "@pages/Reports";
import Account from "@pages/Account";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/preview", element: <PreviewPage /> },
      { path: "/account", element: <Account /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/tracker", element: <Tracker /> },
          { path: "/manage", element: <Manage /> },
          { path: "/reports", element: <Reports /> },
        ],
      },
    ],
  },
]);
